
import {Component, Prop, Vue} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";
import Telephone from "@/components/Telephone.vue";
import { Getter } from "vuex-class";
import MylobyAutocompleteMultiple from "../generic/autocomplete-multiple.vue";

@Component({
    components: {
        Telephone,
        MylobyAutocompleteMultiple,
    },
})
export default class AddSubordinate extends Vue {

    @Prop({default: null})
    public companyId: number;

    @Getter private isMobile: boolean;

    private rules: object = formRules;
    private showDialog: boolean = false;
    private newManager: any = {};
    private valid: boolean = true;
    private loading: boolean = false;

    private init(): void {
        this.newManager = {};
        this.showDialog = false;
    }

    private addManager(): void {
        this.loading = true;
        this.$store.dispatch("companies/addSubordinate", {
            companyId: this.companyId,
            subordinate: this.newManager,
        }).then((res) => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$t("management.added", {
                    managerName: this.newManager.firstName + " " + this.newManager.lastName,
                }),
            });
            this.$emit("reset");
            this.init();
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loading = false;
        });
    }

    private fetchSubordinateGroups({search, page, itemsPerPage}: { search: string, page: number, itemsPerPage: number },
    ): Promise<{ count: number; rows: any[] }> {
        return this.$store.dispatch("companies/getUserGroups", {
            id: this.companyId,
            query: {
            search,
            page,
            itemsPerPage,
            type: "subordinates",
            excludeScoped: true,
            },
        }).then((data) => ({ count: data.count, rows: data.list }));
    }
}
